export const NAV_HEIGHT = 55;
export const NAV_HEIGHT_WITH_MARGIN = NAV_HEIGHT + 16;
